<script setup>
import Card from "@/Components/Card.vue";
import FormInput from "@/Components/Form/FormInput.vue";
import FancyButton from "@/Components/Buttons/FancyButton.vue";
import {ref} from "vue";
import {Inertia} from "@inertiajs/inertia";
import {Link} from "@inertiajs/inertia-vue3";
import {route} from "@/Scripts/Routing/Router.js";

const props = defineProps({
    errors: Object,
    status: String,
});

const credentials = ref({
    username: '',
    password: '',
})

const submitting = ref(false);
const submit = () => {
    submitting.value = true;
    Inertia.post(route('login'), credentials.value, {
        onFinish: () => {
            submitting.value = false;
        }
    })
}

</script>

<template>
    <form method="post" action="#" @submit.prevent="submit">
        <Card v-if="!!status" title="Authentication status">
            {{ status }}
        </Card>

        <FormInput type="text" label="Email Address/Username" id="email" v-model="credentials.username" :is-invalid="!!errors.username">
            <template #invalid-message>
                {{ errors.username }}
            </template>
        </FormInput>
        <FormInput type="password" label="Password" id="password" v-model="credentials.password" :is-invalid="!!errors.password">
            <template #invalid-message>
                {{ errors.password }}
            </template>
        </FormInput>

        <div class="md:flex justify-between items-center space-y-3 md:space-y-0">
            <div>
                <FancyButton type="button" :submit="true" :busy="submitting">LOGIN</FancyButton>
            </div>
            <div class="md:text-right">
                Forgot your password?<br />
                <Link :href="route('password.request')" class="text-primary hover:underline">Reset it here</Link>.
            </div>
        </div>
    </form>
</template>

<style scoped>

</style>
